module.exports = __webpack_public_path__ + "img/Picture5.f302e9d8.png";